<template>
    <div class="d-block" v-if="data">
        <div class="d-block pb-lg align-center">
            <h1>{{ data.title }}</h1>
            <span class="space">&nbsp;</span>
            <h2>{{ data.introduction }}</h2>
        </div>
        <div class="photo-contrast">
            <div :class="{bottom: index === 0, middle: index === 1, top: index === 2}" v-for="(item, index) in data.images" :key="index">
                <img :src="item" draggable="false">
            </div>
            <a class="scroller scroller-top">
                <Icon color="#19be6b" type="md-code-working" size="24"/>
            </a>
            <a class="scroller scroller-middle">
                <Icon color="#19be6b" type="md-code-working" size="24"/>
            </a>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
            }
        },
        props: ['data'],
        mounted() {
            console.log(this.data);
            this.photoContrast();
        },
        methods: {
            photoContrast() {
                let active = false;
                let scrollerMiddle = document.querySelector('.scroller-middle');
                let scrollerTop = document.querySelector('.scroller-top');

                scrollerMiddle.addEventListener('mousedown',function(){
                    active = "middle";
                    scrollerMiddle.classList.add('scrolling');
                });
                document.body.addEventListener('mouseup',function(){
                    active = false;
                    scrollerMiddle.classList.remove('scrolling');
                });
                document.body.addEventListener('mouseleave',function(){
                    active = false;
                    scrollerMiddle.classList.remove('scrolling');
                });
                scrollerTop.addEventListener('mousedown',function(){
                    active = "top";
                    scrollerTop.classList.add('scrolling');
                });
                document.body.addEventListener('mouseup',function(){
                    active = false;
                    scrollerTop.classList.remove('scrolling');
                });
                document.body.addEventListener('mouseleave',function(){
                    active = false;
                    scrollerTop.classList.remove('scrolling');
                });

                document.body.addEventListener('mousemove',function(e){
                    if (!active) return;
                    let x = e.pageX;
                    x -= document.querySelector('.photo-contrast').getBoundingClientRect().left;
                    scrollIt(x);
                });

                function scrollIt(x){
                    let transform = Math.max(0,(Math.min(x,document.querySelector('.photo-contrast').offsetWidth)));
                    if (active === "middle"){
                        document.querySelector('.middle').style.width = transform + "px";
                        scrollerMiddle.style.left = transform - 20 + "px";
                        if (scrollerTop.getBoundingClientRect().left > scrollerMiddle.getBoundingClientRect().left - 5){
                            document.querySelector('.top').style.width = transform - 5 + "px";
                            scrollerTop.style.left = transform - 20 + "px";
                        }
                    }
                    if (active === "top"){
                        document.querySelector('.top').style.width = transform+"px";
                        scrollerTop.style.left = transform - 20 + "px";
                        if (scrollerTop.getBoundingClientRect().left > scrollerMiddle.getBoundingClientRect().left - 5){
                            document.querySelector('.middle').style.width = transform + 5 + "px";
                            scrollerMiddle.style.left = transform - 20 + "px";
                        }
                    }
                }
                active = "middle";
                scrollIt(852);
                active = "top";
                scrollIt(426);
                active = false;
                scrollerMiddle.addEventListener('touchstart',function(){
                    active = "middle";
                    scrollerMiddle.classList.add('scrolling');
                });
                document.body.addEventListener('touchend',function(){
                    active = false;
                    scrollerMiddle.classList.remove('scrolling');
                });
                document.body.addEventListener('touchcancel',function(){
                    active = false;
                    scrollerMiddle.classList.remove('scrolling');
                });
                scrollerTop.addEventListener('touchstart',function(){
                    active = "top";
                    scrollerTop.classList.add('scrolling');
                });
                document.body.addEventListener('touchend',function(){
                    active = false;
                    scrollerTop.classList.remove('scrolling');
                });
                document.body.addEventListener('touchcancel',function(){
                    active = false;
                    scrollerTop.classList.remove('scrolling');
                });

                document.querySelector('.photo-contrast').addEventListener('touchmove',function(e){
                    if (!active) return;
                    e.preventDefault();
                    let x = e.touches[0].pageX;
                    x -= document.querySelector('.photo-contrast').getBoundingClientRect().left;
                    scrollIt(x);
                });
            }
        }
    }
</script>

<style type="text/css">
    .photo-contrast{
        display: block;
        box-sizing: content-box;
        position: relative;
        width: 1280px;
        height: 800px;
        transform: translate3d(-50%, -50%);
        overflow:hidden;
    }
    .photo-contrast .bottom,
    .photo-contrast .middle,
    .photo-contrast .top {
        width:100%;
        height:100%;
        background-repeat:no-repeat;
        background-color: white;
        background-size: cover;
        background-position: center;
        position: absolute;
        top:0;
        left:0;
        pointer-events:none;
        overflow: hidden;
    }

    .photo-contrast .top{
        width:125px;
    }

    .photo-contrast .scroller{
        position: absolute;
        display: flex;
        display: -webkit-flex;
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        left: 100px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        background-color: #fff;
        transition: opacity 0.12s ease-in-out;
        pointer-events:auto;
        cursor: pointer;
        border: 3px solid #28bd6e;
        justify-content: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items:center;
        align-items: center;
    }
    .photo-contrast .scroller-middle{
        margin-top: 25px;
    }
    .photo-contrast .scroller-top{
        margin-top: -25px;
    }

    .photo-contrast .scroller:hover{
        opacity:1;
    }

    .photo-contrast .scrolling{
        pointer-events:none;
        opacity: 1;
        z-index: 1;
    }

    .photo-contrast .scroller__thumb{
        width:100%;
        height:100%;
        border-radius:50%;
        padding: 7px;
    }

    .photo-contrast .scroller:before,
    .photo-contrast .scroller:after{
        content: "";
        box-sizing: content-box;
        position: absolute;
        width: 4px;
        height: 9999px;
        left: 50%;
        margin-left: -2px;
        z-index: 30;
        transition: 0.1s;
    }
    .photo-contrast .scroller:before{
        top: 36px;
    }
    .photo-contrast .scroller:after{
        bottom: 36px;
    }
    .photo-contrast .scroller-middle:before,
    .photo-contrast .scroller-middle:after{
        background: #28bd6e;
    }
    .photo-contrast .scroller-top:before,
    .photo-contrast .scroller-top:after{
        background: #28bd6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/PhotoContrast.vue